// @flow

import { IMMERSIVE } from 'Client/cms/toolkit/constants';

import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { LINE_COMMON_IMMERSIVE } from 'Utils/request/requestDictionary';
import * as configQueries from 'Views/configQueries';

type CMSProps = {
  displaySearch?: boolean,
};

export const immersiveResolver = {
  name: IMMERSIVE,
  resolve: async (appContext: AppContext, props: CMSProps) => {
    const { displaySearch } = props;
    const query = `query {
      config {
        ${configQueries.searchRemote()}
        ${configQueries.resort(appContext)}
        ${configQueries.price()}
        ${configQueries.faceting()}
      }
    }`;

    if (displaySearch) {
      return graphQLClient
        .runQuery(query, appContext, {
          requestName: LINE_COMMON_IMMERSIVE,
        })
        .then(data => ({ ...data }));
    }

    return Promise.resolve({});
  },
};
